module.exports = __webpack_public_path__ + "static/column-with-negative-values-dd91dd735b23029653a9e9afba66f455.png";